import { createSlice } from "@reduxjs/toolkit";

export const AccordionSlice = createSlice({
    name: "Accordion",
    initialState: {
        expandedAccordion: "pine",
    },
    reducers: {
        setExpandedAccordion: (state, action) => {
            state.expandedAccordion = action.payload;
        },
    },
});

export const { setExpandedAccordion } = AccordionSlice.actions;

export const selectedExpandedAccordion = (state) => state.Accordion.expandedAccordion;

export default AccordionSlice.reducer;
